/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_Payment_DateInputs */

const en_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next payment date`)
};

const id_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal pembayaran berikutnya`)
};

const ms_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh pembayaran seterusnya`)
};

const ca_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pròxima data de pagament`)
};

const cs_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další datum platby`)
};

const da_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste betalingsdato`)
};

const de_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächstes Zahlungsdatum`)
};

const et_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järgmine maksekuupäev`)
};

const es_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha del siguiente pago`)
};

const fr_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date du prochain paiement`)
};

const hr_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sljedeći datum plaćanja`)
};

const it_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data del prossimo pagamento`)
};

const lv_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nākamais maksājuma datums`)
};

const lt_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kita mokėjimo data`)
};

const hu_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Következő fizetés dátuma`)
};

const nl_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende betaaldatum`)
};

const nb_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neste betalingsdato`)
};

const pl_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data następnej płatności`)
};

const pt_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próxima data de pagamento`)
};

const ro_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data următoarei plăți`)
};

const sk_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dátum ďalšej platby`)
};

const sl_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum naslednjega plačila`)
};

const fi_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava maksupäivä`)
};

const sv_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa betalningsdatum`)
};

const vi_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày thanh toán tiếp theo`)
};

const tr_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir sonraki ödeme tarihi`)
};

const el_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επόμενη ημερομηνία πληρωμής`)
};

const bg_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следваща дата на плащане`)
};

const ru_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата следующего платежа`)
};

const sr_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следећи датум за плаћање`)
};

const uk_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата наступного платежу`)
};

const ka_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შემდეგი გადახდის თარიღი`)
};

const hi_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगली भुगतान तिथि`)
};

const th_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันครบกำหนดชำระเงินครั้งถัดไป`)
};

const ko_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 결제일`)
};

const zh_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下次付款日期`)
};

const zh_tw_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下次付款日`)
};

const ja_next_payment_date = /** @type {(inputs: Next_Payment_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次の支払日`)
};

/**
* | output |
* | --- |
* | "Next payment date" |
*
* @param {Next_Payment_DateInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const next_payment_date = /** @type {((inputs?: Next_Payment_DateInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_Payment_DateInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_next_payment_date(inputs)
	if (locale === "ms") return ms_next_payment_date(inputs)
	if (locale === "ca") return ca_next_payment_date(inputs)
	if (locale === "cs") return cs_next_payment_date(inputs)
	if (locale === "da") return da_next_payment_date(inputs)
	if (locale === "de") return de_next_payment_date(inputs)
	if (locale === "et") return et_next_payment_date(inputs)
	if (locale === "es") return es_next_payment_date(inputs)
	if (locale === "fr") return fr_next_payment_date(inputs)
	if (locale === "hr") return hr_next_payment_date(inputs)
	if (locale === "it") return it_next_payment_date(inputs)
	if (locale === "lv") return lv_next_payment_date(inputs)
	if (locale === "lt") return lt_next_payment_date(inputs)
	if (locale === "hu") return hu_next_payment_date(inputs)
	if (locale === "nl") return nl_next_payment_date(inputs)
	if (locale === "nb") return nb_next_payment_date(inputs)
	if (locale === "pl") return pl_next_payment_date(inputs)
	if (locale === "pt") return pt_next_payment_date(inputs)
	if (locale === "ro") return ro_next_payment_date(inputs)
	if (locale === "sk") return sk_next_payment_date(inputs)
	if (locale === "sl") return sl_next_payment_date(inputs)
	if (locale === "fi") return fi_next_payment_date(inputs)
	if (locale === "sv") return sv_next_payment_date(inputs)
	if (locale === "vi") return vi_next_payment_date(inputs)
	if (locale === "tr") return tr_next_payment_date(inputs)
	if (locale === "el") return el_next_payment_date(inputs)
	if (locale === "bg") return bg_next_payment_date(inputs)
	if (locale === "ru") return ru_next_payment_date(inputs)
	if (locale === "sr") return sr_next_payment_date(inputs)
	if (locale === "uk") return uk_next_payment_date(inputs)
	if (locale === "ka") return ka_next_payment_date(inputs)
	if (locale === "hi") return hi_next_payment_date(inputs)
	if (locale === "th") return th_next_payment_date(inputs)
	if (locale === "ko") return ko_next_payment_date(inputs)
	if (locale === "zh") return zh_next_payment_date(inputs)
	if (locale === "zh-tw") return zh_tw_next_payment_date(inputs)
	if (locale === "ja") return ja_next_payment_date(inputs)
	return en_next_payment_date(inputs)
});